import type {
  PageTemplateParts,
  ProgramTemplateParts,
  ResourceTemplateParts,
} from '@efdigital/ll-addon-content';

import { LinkToCoaching } from './parts/link-to-coaching.gts';
import { LinkToCohortCertificate } from './parts/link-to-cohort-certificate.gts';
import { LinkToCohortPage } from './parts/link-to-cohort-page.gts';
import { LinkToCohortQuiz } from './parts/link-to-cohort-quiz.gts';
import { LinkToContact } from './parts/link-to-contact.gts';
import { LinkToLeadershipLive } from './parts/link-to-leadership-live.gts';
import { LinkToMessages } from './parts/link-to-messages.gts';
import { LinkToModule } from './parts/link-to-module.gts';
import { LinkToModulePage } from './parts/link-to-module-page.gts';
import { LinkToResource } from './parts/link-to-resource.gts';
import { LinkToTeams } from './parts/link-to-teams.gts';
import { ReadingListMenu } from './parts/reading-list-menu.gts';
import { RenderInClientHeader } from './parts/render-in-client-header.gts';
import { RenderInTopNav } from './parts/render-in-top-nav.gts';
import { ShareButton } from './parts/share-button.gts';
import { ShareCert } from './parts/share-cert.gts';
import { SubscriptionView } from './parts/subscription-view.gts';

export const resourceTemplateParts: ResourceTemplateParts = {
  LinkToContact: LinkToContact,
  LinkToResource: LinkToResource,
  ShareButton: ShareButton,
  ShareCert: ShareCert,
  SubscriptionView: SubscriptionView,
  ReadingListMenu: ReadingListMenu,
};

export const pageTemplateParts: PageTemplateParts = {
  LinkToResource: LinkToResource,
  ShareButton: ShareButton,
  ShareCert: ShareCert,
  SubscriptionView: SubscriptionView,
};

export const programTemplateParts: ProgramTemplateParts = {
  LinkToLeadershipLive: LinkToLeadershipLive,
  LinkToCoaching: LinkToCoaching,
  LinkToModule: LinkToModule,
  LinkToModulePage: LinkToModulePage,
  LinkToCohortPage: LinkToCohortPage,
  LinkToCohortQuiz: LinkToCohortQuiz,
  LinkToCohortCertificate: LinkToCohortCertificate,
  RenderInClientHeader: RenderInClientHeader,
  RenderInTopNav: RenderInTopNav,
  LinkToMessages: LinkToMessages,
  LinkToTeams: LinkToTeams,
};
